import { Box, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { LogicalField } from '../../types/dataSource';

export interface TreatmentDateFieldState {
  mode: 'field' | 'fixed';
  sourceColumn: string;
  dateFormat: string;
  fixedDate: string;
}

export const EMPTY_DATE_FIELD: TreatmentDateFieldState = {
  mode: 'field',
  sourceColumn: '',
  dateFormat: '',
  fixedDate: '',
};

interface TreatmentDateFieldProps {
  label: string;
  logicalField: LogicalField;
  value: TreatmentDateFieldState;
  onChange: (value: TreatmentDateFieldState) => void;
  disabled?: boolean;
}

export default function TreatmentDateField({
  label,
  value,
  onChange,
  disabled = false,
}: TreatmentDateFieldProps) {
  const handleModeChange = (mode: 'field' | 'fixed') => {
    onChange({ mode, sourceColumn: '', dateFormat: '', fixedDate: '' });
  };

  return (
    <Box sx={{ p: 1.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>
        {label}
      </Typography>

      <RadioGroup
        row
        value={value.mode}
        onChange={(e) => handleModeChange(e.target.value as 'field' | 'fixed')}
      >
        <FormControlLabel
          value="field"
          control={<Radio size="small" disabled={disabled} />}
          label="Map from field in data"
        />
        <FormControlLabel
          value="fixed"
          control={<Radio size="small" disabled={disabled} />}
          label="Fixed date for all records"
        />
      </RadioGroup>

      {value.mode === 'field' && (
        <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
          <TextField
            size="small"
            label="Field name"
            value={value.sourceColumn}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, sourceColumn: e.target.value })}
            sx={{ flex: 1 }}
          />
          <TextField
            size="small"
            label="Date format"
            value={value.dateFormat}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, dateFormat: e.target.value })}
            placeholder="e.g. YYYY-MM-DD"
            helperText="Leave blank to auto-detect"
            sx={{ flex: 1 }}
          />
        </Box>
      )}

      {value.mode === 'fixed' && (
        <TextField
          size="small"
          type="date"
          label="Date"
          value={value.fixedDate}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, fixedDate: e.target.value })}
          sx={{ mt: 1 }}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      )}
    </Box>
  );
}
